import Vue from 'vue'

import '@/styles/quasar.styl'
import '@quasar/extras/material-icons/material-icons.css'

import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QCard,
  QCardSection,
  QCardActions,
  QCheckbox,
  QInput,
  QMenu,
  ClosePopup,
  QSeparator
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCard,
    QCardSection,
    QCardActions,
    QCheckbox,
    QInput,
    QMenu,
    QSeparator
  },
  directives: {
    ClosePopup
  },
  plugins: {}
})
